// ==========================================
// Blue Signature - Interactions & Animations
// ==========================================

document.addEventListener('DOMContentLoaded', () => {
    
    // 1. Sticky Navigation highlighting
    const navLinks = document.querySelectorAll('.nav-link');
    
    navLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            // Remove active from all
            navLinks.forEach(nav => nav.classList.remove('active'));
            // Add active to clicked
            this.classList.add('active');
        });
    });

    // 2. Simple Smooth Scroll for Anchor Links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const targetId = this.getAttribute('href');
            if (targetId === '#') return;
            
            const targetElement = document.querySelector(targetId);
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        });
    });

    // 3. Hero Slider Logic
    const slides = document.querySelectorAll('.hero-slide');
    const prevBtn = document.querySelector('.carousel-control.prev');
    const nextBtn = document.querySelector('.carousel-control.next');
    const indicators = document.querySelectorAll('.slider-indicators .indicator');
    
    let currentSlide = 0;
    const slideCount = slides.length;
    let autoSlideInterval;

    if (slides.length > 0) {
        function goToSlide(index) {
            // Remove active class from all slides and indicators
            slides.forEach(slide => slide.classList.remove('active'));
            indicators.forEach(ind => ind.classList.remove('active'));
            
            // Re-trigger text animations
            const texts = document.querySelectorAll('.text-block');
            texts.forEach(text => {
                text.style.animation = 'none';
                text.offsetHeight; /* trigger reflow */
                text.style.animation = null; 
            });

            // Set current index, wrapping around if necessary
            currentSlide = (index + slideCount) % slideCount;
            
            // Add active class to new slide and indicator
            slides[currentSlide].classList.add('active');
            if(indicators.length > currentSlide) {
                indicators[currentSlide].classList.add('active');
            }
            
            resetAutoSlide();
        }

        function nextSlide() {
            goToSlide(currentSlide + 1);
        }

        function prevSlide() {
            goToSlide(currentSlide - 1);
        }

        function startAutoSlide() {
            autoSlideInterval = setInterval(nextSlide, 5000); // Change slide every 5 seconds
        }

        function resetAutoSlide() {
            clearInterval(autoSlideInterval);
            startAutoSlide();
        }

        if (prevBtn) prevBtn.addEventListener('click', prevSlide);
        if (nextBtn) nextBtn.addEventListener('click', nextSlide);

        indicators.forEach((indicator, index) => {
            indicator.addEventListener('click', () => {
                goToSlide(index);
            });
        });

        startAutoSlide();
    }

    // 4. Typewriter Search Input Placeholder Animation
    const searchInputs = document.querySelectorAll('.search-input');
    if (searchInputs.length > 0) {
        let placeholders = [];

        // Check if dynamic collections exist on the search input attribute
        const firstInput = searchInputs[0];
        const dataCollections = firstInput.getAttribute('data-collections');
        
        if (dataCollections && dataCollections.trim() !== '') {
            const collectionTitles = dataCollections.split('|').map(t => t.trim()).filter(t => t.length > 0);
            if (collectionTitles.length > 0) {
                placeholders = collectionTitles.map(title => `Search ${title}`);
            }
        }

        // Dummy fallbacks if no shop collections exist
        if (placeholders.length === 0) {
            placeholders = [
                "Search Automatic Watches",
                "Search Chronograph Watches",
                "Search Men's Luxury Watches",
                "Search Women's Elegant Watches",
                "Search Premium Leather Collections"
            ];
        }

        let wordIndex = 0;
        let charIndex = 0;
        let isDeleting = false;
        let typingSpeed = 100;

        function typeEffect() {
            const currentWord = placeholders[wordIndex];

            if (isDeleting) {
                charIndex--;
                typingSpeed = 50;
            } else {
                charIndex++;
                typingSpeed = 100;
            }

            const displayedText = currentWord.substring(0, charIndex);
            searchInputs.forEach(input => {
                input.setAttribute('placeholder', displayedText);
            });

            if (!isDeleting && charIndex === currentWord.length) {
                typingSpeed = 2000; // Pause at end of word
                isDeleting = true;
            } else if (isDeleting && charIndex === 0) {
                isDeleting = false;
                wordIndex = (wordIndex + 1) % placeholders.length;
                typingSpeed = 500; // Pause before typing next word
            }

            setTimeout(typeEffect, typingSpeed);
        }

        typeEffect();
    }

    // 5. Global Get Started Side Tab & Drawer Logic
    const wrapper = document.querySelector('.get-started-wrapper');
    const tab = document.querySelector('.floating-side-tab');
    const overlay = document.querySelector('.drawer-overlay');
    const closeBtn = document.querySelector('.drawer-close-btn');

    if (tab && wrapper) {
        // Enforce visible tab class
        tab.classList.add('tab-visible');

        tab.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            wrapper.classList.toggle('drawer-open');
        });

        if (overlay) {
            overlay.addEventListener('click', () => {
                wrapper.classList.remove('drawer-open');
            });
        }

        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                wrapper.classList.remove('drawer-open');
            });
        }
    }

});
